import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useMutation } from '@apollo/client'
import styles from './unlinkApiClientDaycareDialog.module.scss'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import { UNLINK_API_CLIENT_FROM_DAYCARE } from '@/modules/API/apiClient/linkApiClient.ts'
import { ApiClientDaycare } from '@/types/ApiClient.ts'
import { Close, Delete } from '@mui/icons-material'

interface UnlinkDaycareDialogProps {
    open: boolean
    handleClose: () => void
    daycare: ApiClientDaycare
    id: number
    refetch: () => void
}

const UnlinkApiClientDaycareDialog: FunctionComponent<UnlinkDaycareDialogProps> = ({
    open,
    handleClose,
    daycare,
    id,
    refetch
}: UnlinkDaycareDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [unlinkDaycare] = useMutation(UNLINK_API_CLIENT_FROM_DAYCARE, {
        variables: {
            id: id,
            daycareId: daycare.id
        },
        onCompleted: () => {
            showNotificationSuccess(t('daycareUnlinked'))

            refetch()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorUnlinkingDaycare'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('confirmUnlinkDaycare')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmUnlinkDaycareMessage')}</p>
                <p className={styles.Informations}>
                    {daycare.city} - {daycare.name} #{id}
                </p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={unlinkDaycare}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default UnlinkApiClientDaycareDialog
